import ApiModel         from '@widesk-core/models/ApiModel';
import FileModel        from '@/models/services/website/FileModel';
import WebsiteConnector from '@/models/WebsiteConnector';
import config           from '@/config';

class FileCopyConnector extends WebsiteConnector {
	public async save(model: ApiModel, options: ConnectorSaveOptions = {}) {
		return super.save(model, {
			...options,
			headers: { ...options.headers, 'Content-Type': 'application/json' } as any,
		});
	}
}

const fileCopyConnector = new FileCopyConnector({
	baseURL: config.api_endpoint + `/website`,
});

export default class FileCopyModel extends FileModel {
	static get path(): string {
		return '/stonecode_file_files/copy';
	}

	public static get connector() {
		return fileCopyConnector;
	}

	declare file: Urn;
}
